var exports = {
  "qr": "xfd349460--12af1e--footer",
  "h_": "xfd349460--12af1e--description",
  "x6": "xfd349460--12af1e--button",
};

module.exports = exports;
